<template>
  <div class="logout">
    Logout
  </div>
</template>

<script>

export default {
  name: 'Logout',
  created () {
    const userType = this.$store.getters.user_type
    this.$store.dispatch('AUTH_LOGOUT').then(() => {
      this.$router.push({name: 'LOGIN_' + userType})
      // window.location.href = '/'
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Logout.vue